import mitt from 'mitt';

export const bus = mitt();

export default {
    install: ({provide}) => {
        provide('bus', bus);
    },
}; 
